import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateModel } from 'src/app/shared/models/date.model';
import { DateService } from 'src/app/shared/service/date.service';
import { ValidationErrorComponent } from '../validation-error/validation-error.component';
import { NbButtonModule, NbSelectModule, NbSpinnerModule } from '@nebular/theme';
import { DatepickerComponent } from '../datepicker/datepicker.component';

@Component({
  selector: 'app-range-picker',
  templateUrl: './range-picker.component.html',
  styleUrls: ['./range-picker.component.scss'],
  standalone: true,
  imports: [ValidationErrorComponent,NbButtonModule, NbSelectModule, DatepickerComponent, NbSpinnerModule]
})
export class RangePickerComponent implements OnInit {
  @Output() submit = new EventEmitter();
  @Input() errors = {};
  @Input() loading = false;

  startDate!: string;
  endDate!: string;
  jalaliStartDate!: DateModel;
  jalaliEndDate!: DateModel;

  constructor(private dateService: DateService) {}

  getDates(): void {
    this.submit.emit({
      startDate: this.startDate,
      endDate: this.endDate
    });
  }

  setStart(event: DateModel): void {
    this.startDate = this.dateService.convertDateToStringGregorian(event) ?? '';
  }

  setEnd(event: DateModel): void {
    this.endDate = this.dateService.convertDateToStringGregorian(event) ?? '';
  }

  ngOnInit(): void {
    this.endDate = this.dateService.todayStringGregorian();
    this.startDate = this.dateService.previousMonth();
    this.jalaliStartDate = this.dateService.convertStringDateToDate(this.startDate);
    this.jalaliEndDate = this.dateService.convertStringDateToDate(this.endDate);
  }
}
